<template>
  <div>
    <el-dialog
      title="话题"
      :visible.sync="dialogMyTopicVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseDialog"
    >
      <el-form :model="form" ref="form" :rules="rules">
        <el-input v-model="form.id" type="hidden"></el-input>
        <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
          <el-input v-model.trim="form.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="封面" :label-width="formLabelWidth">
          <div class="face">
            <img
              :src="form.cover"
              :alt="form.title"
              style="width:275px; height:208px;"
              v-if="form.cover"
            />
          </div>
          <el-upload
            action=""
            accept="image/png, image/jpeg"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="changeUpload"
          >
            <h3>更换封面图（2M以内）</h3>
          </el-upload>
        </el-form-item>
        <el-form-item label="权限" prop="title" :label-width="formLabelWidth">
          <el-radio-group v-model="form.is_open">
            <el-radio :label="true">公开</el-radio>
            <el-radio :label="false">私密</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="描述"
          prop="description"
          :label-width="formLabelWidth"
        >
          <el-input
            type="textarea"
            v-model.trim="form.description"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCloseMyTopic">取 消</el-button>
        <el-button type="primary" @click.native="handleSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <div class="uc-userCenterTitle">
      <div class="left">
        <b>我的话题</b>
        <div class="tips">
          <a
            href="javascript:;"
            @click="dialogMyTopicVisible = true"
            class="uc-btn blue-plain el-icon-plus"
            >新增话题</a
          >
        </div>
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="请输入搜索关键字"
          class="uc-input"
          v-model="query.keyword"
        />
        <a
          href="javascript:;"
          @click="
            query.pageIndex = 1;
            initData();
          "
          class="uc-btn blue"
          ><i class="uc-font uc-search"></i
        ></a>
      </div>
    </div>

    <section class="uc-userCenterTitleTab3 bg-white">
      <div class="table">
        <table>
          <tr>
            <th>序</th>
            <th style="width:30%;" class="left">标题</th>
            <th style="width:18%;">描述</th>
            <th style="width:10%;">发布</th>
            <th style="width:22%;">时间</th>
            <th style="width:10%;">操作</th>
          </tr>
          <tr v-if="list.total_count == 0">
            <td colspan="6">
              <div class="content-empty">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
            </td>
          </tr>

          <tr v-for="(item, index) in list.items" :key="index">
            <td>{{ item.row }}</td>
            <td class="left">
              <b>{{ item.title }}</b>
            </td>
            <td>
              {{ item.description }}
            </td>
            <td class="uc-orange">
              <b>{{ item.is_published == 1 ? '已审核' : '未审核' }}</b>
            </td>
            <td>{{ item.create_time }}</td>
            <td>
              <router-link to="">
                <el-tooltip content="编辑" placement="top">
                  <i
                    class="el-icon-edit-outline"
                    @click="
                      dialogMyTopicVisible = true;
                      getMyTopicDetails(item.id);
                    "
                  ></i>
                </el-tooltip>
              </router-link>
              <router-link to="">
                <el-tooltip content="删除" placement="top">
                  <i
                    class="el-icon-delete uc-ml15"
                    @click="handelDeleteMyTopic(item)"
                  ></i>
                </el-tooltip>
              </router-link>
            </td>
          </tr>
        </table>
      </div>
    </section>
    <!-- vueCropper 剪裁图片实现-->
    <el-dialog
      title="上传话题"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="option.info"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
            :high="option.high"
            @realTime="realTime"
            @imgLoad="imgLoad"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="finish('blob', form.id)"
          :loading="loading"
          >确认上传</el-button
        >
      </div>
    </el-dialog>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper';
export default {
  name: 'PersonalMyTopic',
  components: {
    VueCropper,
  },
  data() {
    return {
      dialogMyTopicVisible: false,
      query: {
        pageIndex: 1,
        pageSize: 10,
        keyword: undefined,
      },
      list: [],
      gridData: [],
      form: {
        id: 0,
        title: '',
        description: '',
        cover: '',
      },
      rules: {
        name: [{ required: true, message: '请输入话题名称', trigger: 'blur' }],
      },
      dialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        size: 1,
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        info: true, // 裁剪框的大小信息
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 275, // 默认生成截图框宽度
        autoCropHeight: 208, // 默认生成截图框高度
        //fixed: true, // 是否开启截图框宽高固定比例
        //fixedNumber: [1, 1], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        fixedBox: true, // 固定截图框大小 不允许改变
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        high: true, // 是否按照设备的dpr 输出等比例图片
      },
      // 防止重复提交
      loading: false,
      formLabelWidth: '100px',
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getMyTopic();
    },
    async getMyTopic() {
      const response = await this.$api.topic.getMyTopic(this.query);
      this.list = response.data.data;
    },
    // 获取话题详情
    async getMyTopicDetails(MyTopicId) {
      const response = await this.$api.topic.getMyTopicDetails({
        id: MyTopicId,
      });
      this.form = response.data.data;
    },
    // 上传按钮 限制图片大小
    changeUpload(file, fileList) {
      const imgType = ['image/jpeg', 'image/jpg', 'image/png'];
      const imgIndex = imgType.indexOf(file.raw.type);
      // console.log(file.raw.type);
      if (imgIndex === -1) {
        this.$message.error('上传文件只能是 png或jpg 格式!');
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 2MB!');
        return false;
      }
      this.fileinfo = file;

      this.$nextTick(() => {
        this.option.img = window.URL.createObjectURL(file.raw);
        this.dialogVisible = true;
      });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish(type, id) {
      if (type === 'blob') {
        // 获取截图的blob数据
        this.$refs.cropper.getCropBlob((data) => {
          this.loading = true;
          // 上传
          this.handleSubmitCover(data, id);
        });
      } else {
        // 获取截图的base64 数据
        this.$refs.cropper.getCropData((data) => {
          this.loading = true;
          // 上传
          this.handleSubmitCover(data, id);
        });
      }
    },
    imgLoad(msg) {
      console.log('imgLoad');
      console.log(msg);
    },
    // 预览
    realTime(data) {
      this.previews = data;
    },
    // 更新封面图
    handleSubmitCover(data, id) {
      const fileName = this.fileinfo.uid + this.fileinfo.name;
      // console.log(fileName);

      const formData = new FormData();
      formData.append('cover', data, fileName); // 添加到请求体
      // var dataparm={cover:formData,id:id};
      // 上传
      this.updateCover(formData);
    },
    // 更新封面图
    async updateCover(myCover) {
      const response = await this.$api.topic.updateCover(myCover);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        // 设置封面图回显
        this.form.cover = response.data.data;
        this.loading = false;
        this.dialogVisible = false;
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 提交数据
    handleSubmitSure() {
      const submitData = {
        id: this.form.id,
        title: this.form.title,
        description: this.form.description,
        cover: this.form.cover,
        assign_type: 0,
        topic_type: 'UserTopic',
        is_open: this.is_open,
        is_published: '0',
        assign_type: 0,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.postMyTopic(submitData);
        }
      });
    },
    async postMyTopic(myMyTopic) {
      const response = await this.$api.topic.postMyTopic(myMyTopic);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);

        this.dialogMyTopicVisible = false;
        this.initData();
        // 清空表单
        this.$nextTick(() => {
          this.$refs.form.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    handleCloseMyTopic() {
      this.dialogMyTopicVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.form.resetFields();
      });
    },
    handleCloseDialog() {
      this.$refs.form.resetFields();
    },
    handelDeleteMyTopic(item) {
      const confirmText = [
        '确定要删除该话题吗？',
        '注意：删除之后对应话题的内容也会释放！',
      ];
      const newDatas = [];
      const h = this.$createElement;
      for (const i of Object.keys(confirmText)) {
        newDatas.push(h('p', null, confirmText[i]));
      }
      this.$confirm('提示', {
        type: 'warning',
        title: '提示',
        message: h('div', null, newDatas),
      })
        .then(() => {
          this.$api.topic.deleteMyTopic({ id: item.id }).then((response) => {
            if (response.data.code === 200) {
              this.list.items.splice(this.list.items.indexOf(item), 1);
              this.$message.success(response.data.message);
            } else {
              this.$message.warning(response.data.message);
            }
          });
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
  },
};
</script>
